import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { FormControlLabel, Checkbox as MUICheckbox, } from '@mui/material';
import { ClassNames } from '@emotion/react';
import { formControlStyles as classes } from '../formControlStyles';
/**
 * A component that allows the user to toggle between checked and not checked.
 */
export const Checkbox = ({ label, id, name, disabled, hiddenLabel, onChange, onBlur, onFocus, checked, labelColor, checkedColor, uncheckedColor, value, defaultChecked, labelPlacement, className, ref, }) => {
    return (_jsx(ClassNames, { children: ({ css }) => (_jsx(FormControlLabel, { disabled: disabled, ref: ref, control: _jsx(MUICheckbox, { defaultChecked: defaultChecked, checked: checked, value: value, onFocus: onFocus, onBlur: onBlur, onChange: onChange, name: name, disabled: disabled, id: id, inputProps: {
                    'aria-label': hiddenLabel && typeof label === 'string' ? label : undefined,
                }, css: [
                    classes.formControlLabelInput(labelPlacement),
                    classes.checkbox(uncheckedColor, checkedColor),
                ] }), label: !hiddenLabel ? label : '', classes: {
                label: css(classes.formControlLabelText(labelColor)),
            }, labelPlacement: labelPlacement, css: classes.formControlLabelRoot(labelPlacement), className: className })) }));
};
